var map = {
	"./ai_blue.png": 686,
	"./backend_blue.png": 9996,
	"./carbon_visuals.jpg": 2094,
	"./charitywater.jpg": 6978,
	"./digital cafe.jpg": 3760,
	"./emergingradiance.jpg": 7758,
	"./favicon.png": 5963,
	"./filtacopy.jpg": 6048,
	"./framehangerpro.jpg": 388,
	"./frontend_blue.png": 4056,
	"./fullstack.svg": 1272,
	"./gamedev.svg": 5518,
	"./header.png": 1972,
	"./multimedia.svg": 4490,
	"./nebula.jpg": 5970,
	"./preview.jpg": 9319,
	"./puzzlebox.jpg": 4952,
	"./selfie.jpg": 2031,
	"./selfie3.jpg": 4480,
	"./socialar.jpg": 6535,
	"./winter lights festival.jpg": 1437
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;